import { render, staticRenderFns } from "./giftExchangeResetNum.vue?vue&type=template&id=3133034c&scoped=true"
import script from "./giftExchangeResetNum.vue?vue&type=script&lang=js"
export * from "./giftExchangeResetNum.vue?vue&type=script&lang=js"
import style0 from "./giftExchangeResetNum.vue?vue&type=style&index=0&id=3133034c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3133034c",
  null
  
)

export default component.exports